import { useMemo } from 'react';
import { useWatch } from 'react-hook-form';

import { ApplyFormFieldValues } from 'pages/Apply/context';

export interface SecondaryEmploymentHook {
  showButton: boolean;
}

export default function useSecondaryEmployment(): SecondaryEmploymentHook {
  const employmentStatus = useWatch<
    ApplyFormFieldValues,
    'credit.employment_details.employment_status'
  >({
    name: 'credit.employment_details.employment_status',
  });

  const showButton = useMemo(
    () => Boolean(employmentStatus),
    [employmentStatus],
  );

  return {
    showButton,
  };
}
